module.exports = __webpack_public_path__ + "static/media/pause.fbd1bc61.svg";